import React, { useState, useEffect, useRef } from 'react'
import { Panel, Row, Col, Table } from 'rsuite'

import PanelHeader from '../../../components/PanelHeader/PanelHeader'
import IncomeRecordFileTable from '../../incomeRecordWidget/IncomeRecordFileTable'
import { startLoading, doneLoading } from '../../../utils/loading'
import notification from '../../../utils/notification'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import { downloadBlacklistAttacthment } from '../../../redux/actions/blacklist'
import { getDateThaiShortDash, getValueFromOptions, maskIdCard } from '../../../utils/dataUtil'

export default function ViewAddBlacklistForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  setIsEnableEdit = () => {},
  ...props
}) {
  const triggerRef = React.useRef()
  const { Column, HeaderCell, Cell } = Table
  const [formSchema, setFormSchema] = useState(_schema)
  const [fileTableData, setFileTableData] = useState([])
  const [titleLeftStr, setTitleLeftStr] = useState('')
  const [titleRightStr, setTitleRightStr] = useState('')

  useEffect(() => {
    register('deleteFileIds', [])
    if (formSchema?.attachFiles?.values && formSchema?.attachFiles?.values?.length > 0) {
      setFileTableData(formSchema?.attachFiles?.values)
    }
  }, [formSchema])

  const onPreview = async (fileObj) => {
    // console.log('onPreview', fileObj)
    startLoading()
    try {
      var file = await downloadBlacklistAttacthment(fileObj.id)
      var fileName = fileObj.label

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    // console.log('onDownload', fileObj)
    startLoading()
    try {
      var file = await downloadBlacklistAttacthment(fileObj.id)
      var fileName = fileObj.label

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  return (
    <>
      <Panel
        bordered
        style={{
          marginTop: 25,
          border: '1px solid #4e4b488c',
        }}
        header={<PanelHeader leftString={titleLeftStr} rightString={titleRightStr} />}
      >
        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginLeft: -10 }}>
            {formSchema.blacklistType.label}
            {' : '}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {`${getValueFromOptions(
              formSchema.blacklistType.options,
              formSchema.blacklistType.value
            )}`}
          </Col>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}></Col>
          <Col lg={8} md={8} sm={24} xs={24}></Col>
        </Row>
        {formSchema?.blacklistType.value == '1' && (
          <>
            <Row style={{ marginTop: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginLeft: -10 }}>
                {formSchema.idCard.label}
                {' : '}
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                {maskIdCard(formSchema.idCard.value)}
              </Col>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                {formSchema.personName.label}
                {' : '}
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                {formSchema.personName.value}
              </Col>
            </Row>
          </>
        )}
        {formSchema?.blacklistType.value == '2' && (
          <>
            <Row style={{ marginTop: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginLeft: -10 }}>
                {formSchema.taxNumber.label}
                {' : '}
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                {formSchema.taxNumber.value}
              </Col>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                {formSchema.juristicName.label}
                {' : '}
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                {formSchema.juristicName.value}
              </Col>
            </Row>
          </>
        )}
        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginLeft: -10 }}>
            {formSchema.startDate.label}
            {' : '}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {`${getDateThaiShortDash(formSchema.startDate.value)}`}
          </Col>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.endDate.label}
            {' : '}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {`${getDateThaiShortDash(formSchema.endDate.value)}`}
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginLeft: -10 }}>
            {formSchema.blacklistAbandonmentType.label}
            {' : '}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {`${getValueFromOptions(
              formSchema.blacklistAbandonmentType.options,
              formSchema.blacklistAbandonmentType.value
            )}`}
          </Col>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.blacklistStatus.label}
            {' : '}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {`${getValueFromOptions(
              formSchema.blacklistStatus.options,
              formSchema.blacklistStatus.value
            )}`}
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginLeft: -10 }}>
            {formSchema.note.label}
            {' : '}
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            {formSchema.note.value}
          </Col>
        </Row>

        {formSchema.relateProject.values.length > 0 && (
          <Row>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginLeft: -10 }}>
              โครงการที่เกี่ยวข้อง :
            </Col>
            <Col lg={20} md={20} sm={24} xs={24}>
              <Table
                autoHeight={
                  formSchema.relateProject.values && formSchema.relateProject.values.length < 5
                }
                height={300}
                rowHeight={60}
                data={formSchema.relateProject.values}
                bordered
              >
                <Column minWidth={120} flexGrow={1}>
                  <HeaderCell>รหัสโครงการ</HeaderCell>
                  <Cell>
                    {(rowData) => {
                      return rowData.projectCode
                    }}
                  </Cell>
                </Column>

                <Column minWidth={120} flexGrow={1}>
                  <HeaderCell>เกี่ยวข้องเป็น</HeaderCell>
                  <Cell>
                    {(rowData) => {
                      return rowData.relate
                    }}
                  </Cell>
                </Column>

                <Column minWidth={150} flexGrow={1}>
                  <HeaderCell>ผลการพิจารณา</HeaderCell>
                  <Cell>
                    {(rowData, index) => {
                      return getValueFromOptions(
                        formSchema.relateProject.considerResult.options,
                        rowData?.considerResult
                      )
                    }}
                  </Cell>
                </Column>
              </Table>
            </Col>
          </Row>
        )}

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginLeft: -10 }}>
            {formSchema.attachFiles.header || 'เอกสารแนบประกอบ'} {' : '}
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            {fileTableData.length > 0 && (
              <IncomeRecordFileTable
                data={fileTableData}
                deleteable={false}
                onPreview={onPreview}
                onDownload={onDownload}
              />
            )}
          </Col>
        </Row>
      </Panel>
    </>
  )
}
